import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { Audio } from "@components/PreviewComponents/Audio";
import { Image } from "@components/PreviewComponents/Image";
import { ScrollingText } from "@components/PreviewComponents/ScrollingText";
import { Streaming } from "@components/PreviewComponents/Streaming";
import { Video } from "@components/PreviewComponents/Video";
import { Website } from "@components/PreviewComponents/Website";
import { YoutubeLive } from "@components/PreviewComponents/YoutubeLive";

const Container = styled.div`
  position: absolute;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  top: ${({ y = "0" }) => y}px;
  left: ${({ x = "0" }) => x}px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${({ index = 1 }) => 900 - index};
`;

export const BlockItem = ({ item, index }) => {
  // console.log("item :>> ", item);
  const [currentMedia, setCurrentMedia] = useState(null);
  const intervalRef = useRef(null);

  const parseTime = (timeStr) => {
    const [h, m, s] = timeStr.split(":").map(Number);
    return dayjs().hour(h).minute(m).second(s);
  };

  useEffect(() => {
    const updateCurrentMedia = () => {
      const found = item.queue.find((q) => {
        const now = dayjs();
        const startTime = parseTime(q.start_at);
        const endTime = parseTime(q.end_at);
        return now.isBetween(startTime, endTime, "millisecond", "[)");
      });

      setCurrentMedia(found || null);
    };

    updateCurrentMedia(); // initial run

    intervalRef.current = setInterval(updateCurrentMedia, 1000); // อัปเดตทุก 1 วิ

    return () => clearInterval(intervalRef.current);
  }, [item.queue]);

  return (
    <Container
      index={index}
      width={_.get(item, ["width"])}
      height={_.get(item, ["height"])}
      x={_.get(item, ["position_x"])}
      y={_.get(item, ["position_y"])}
    >
      <div style={{ width: "100%", height: "100%" }}>
        {(() => {
          const mediaType = _.get(currentMedia, ["type"]);
          const attribute = _.get(currentMedia, ["attribute"]);
          const id = _.get(currentMedia, ["id"]);
          switch (mediaType) {
            case "image":
              return <Image key={id} attribute={attribute} />;
            case "video":
              return (
                <Video
                  mute={true}
                  key={id}
                  currentMedia={currentMedia}
                  attribute={attribute}
                  width={_.get(item, ["width"])}
                  height={_.get(item, ["height"])}
                />
              );
            case "audio":
              return <Audio key={id} attribute={attribute} />;
            case "website":
              return <Website key={id} attribute={attribute} />;
            case "youtube-live":
              return (
                <YoutubeLive
                  key={id}
                  attribute={attribute}
                  width={_.get(item, ["width"])}
                  height={_.get(item, ["height"])}
                />
              );
            case "running-text":
              return <ScrollingText key={id} attribute={attribute} />;

            case "video-streaming":
              return <Streaming key={id} attribute={attribute} />;

            default:
              return null;
          }
        })()}
      </div>
    </Container>
  );
};
